import { render } from "./DetailContentView.vue?vue&type=template&id=14331c15&scoped=true"
import script from "./DetailContentView.vue?vue&type=script&lang=js"
export * from "./DetailContentView.vue?vue&type=script&lang=js"

import "./DetailContentView.vue?vue&type=style&index=0&id=14331c15&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14331c15"]])

export default __exports__